import { render } from "./PreSurveyQuestion.vue?vue&type=template&id=554edf5b"
import script from "./PreSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./PreSurveyQuestion.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__